import styled, { css } from 'styled-components';

export const Container = styled.div`
  box-shadow: 0 0 13px 0 rgba(36, 36, 41, 0.44);
  background: #2a3142;
  border-radius: 0.25rem;
  padding: 1.25rem;
  margin: 20px 0;
  width: ${props => `${props.size}%`};

  ${props =>
    props.size <= 50 &&
    css`
      & + div {
        margin-left: 10px;
      }
    `}

  h4 {
    display: flex;
    align-items: center;
    svg {
      margin-right: 10px;
    }
  }

  /* Responsivo */
  @media (max-width: 1200px) {
    width: 100%;
    margin-bottom: 10px;

    & + div {
      margin-left: 0;
    }
  }
`;
